import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorEnum } from '../../components/pages/Error/ErrorEnum';
import ErrorPage from '../../components/pages/Error/ErrorPage';
const ProtectedRoutes = ({ children }) => {
    return (_jsx(ErrorBoundary, Object.assign({ fallback: _jsx(ErrorPage, { error: ErrorEnum.GENERIC }) }, { children: children })));
};
export default ProtectedRoutes;
